import React from "react";

function NoContent() {
  return (
    <div
      style={{
        textAlign: "center",
        background: "#cbcaca",
        paddingTop: "100px",
        height: "220px",
      }}
    >
      <h3>The link has expired!</h3>
      <h5>Please request a new link from dealership!</h5>
    </div>
  );
}

export default NoContent;
